import VideoPlayerComponent from './index.vue';

export const VideoPlayerComponentInstall = Vue => {
  const Constructor = Vue.extend(VideoPlayerComponent);
  Vue.component("lw-two-screen-player", Constructor);
};